const S3_UPLOAD_KEY_RE = /csv-uploads\/[^)\n]+/;

const decodeHtmlEntities = (text: string): string =>
  text
    .replace(/&#x([0-9a-fA-F]+);/g, (_, hex) =>
      String.fromCodePoint(parseInt(hex, 16)),
    )
    .replace(/&#(\d+);/g, (_, dec) => String.fromCodePoint(parseInt(dec, 10)));

const extractUploadFilename = (key: string): string => {
  const last = key.trim().split("/").pop() || key;
  return last.replace(/^\d{8}_\d{6}_/, "");
};

export const sanitizeUploadMessage = (
  text: string,
  toBubble: (filename: string) => string,
): string => {
  const match = decodeHtmlEntities(text ?? "").match(S3_UPLOAD_KEY_RE);
  if (!match) return text;
  return toBubble(extractUploadFilename(match[0].trim()));
};
